import { ActivityService } from './activity.service';

export const services = [
  ActivityService,
];
